export const EVENTCAT_BROWSER_CLIENT = {
  category: 'BrowserClient',
  label: 'BrowserClient',
  prefix: 'CLIENT'
};
export const EVENTCAT_DASHBOARD_COSUB_REMINDER = {
  category: 'Co-subReminder',
  label: 'Co-subReminder',
  prefix: 'CSR'
};

export const EVENTCAT_GENESYS_CHAT = {
  category: 'GenesysChat',
  label: 'GenesysChat',
  eventprefix: 'GC'
};

export const EVENTCAT_ADD_A_BENE = {
  category: 'AddABeneFlow',
  label: 'AddABeneFlow',
  eventprefix: 'ADDBENE',
  paths: ['/add-a-beneficiary']
};

export const EVENTCAT_ADD_A_PLAN = {
  category: 'AddAPlanFlow',
  label: 'AddAPlanFlow',
  eventprefix: 'ADDPLAN',
  paths: ['/open-plan']
};

// TODO: Update Auth to use Auth / Auth instead of Onboarding when we implement category override
export const EVENTCAT_AUTH = {
  category: 'Onboarding',
  label: 'Onboarding',
  eventprefix: 'AUTH',
  paths: ['/oauth']
};

export const EVENTCAT_SELF_ONBOARDING = {
  category: 'Onboarding',
  label: 'Onboarding',
  eventprefix: 'ON',
  paths: ['/onboarding']
};

export const EVENTCAT_SELF_COSUB_ONBOARDING_APPLICATION = {
  category: 'CosubOnboarding',
  label: 'CosubOnboarding',
  eventprefix: 'CSON',
  paths: ['/cosubscriber-onboarding']
};

export const EVENTCAT_SELF_ONBOARDING_APPLICATION = {
  category: 'NewUnifiedFlow',
  label: 'NewUnifiedFlow',
  eventprefix: 'NUF',
  paths: ['/newonboarding']
};

export const EVENTCAT_SELF_TRANSFER_IN_APPLICATION = {
  category: 'TransferInForm',
  label: 'TransferInForm',
  eventprefix: 'TIF',
  paths: ['/transfer-in']
};

export const EVENTCAT_AIP_WITHDRAWAL_APPLICATION = {
  category: 'AIPWithdrawals',
  label: 'AIPWithdrawals',
  eventprefix: 'AIPW',
  paths: ['/aip-withdrawal']
};

export const EVENTCAT_SELF_WITHDRAWAL_APPLICATION = {
  category: 'WithdrawalSuccessPage',
  label: 'WithdrawalSuccessPage',
  eventprefix: 'WTA',
  paths: ['/withdrawal']
};

export const EVENTCAT_ASSIS_ONBOARDING = {
  category: 'Assisted Onboarding',
  label: 'Assisted Onboarding',
  eventprefix: 'AON',
  paths: ['/assisted-onboarding']
};

export const EVENTCAT_INTEREST_QUESTIONNAIRE = {
  category: 'InterestQuizFlow',
  label: 'InterestQuizFlow',
  eventprefix: 'IQ',
  paths: ['/interest-questionnaire']
};

export const EVENTCAT_REWARDS = {
  category: 'Rewards Page',
  label: 'Rewards Page',
  eventprefix: 'RP',
  paths: ['/main/rewards']
};

export const EVENTCAT_RESP_DASHBOARD = {
  category: 'RESP_Dashboard',
  label: 'RESPDashboard',
  eventprefix: 'RESP_DASH'
};

export const EVENTCAT_NON_RESP_DASHBOARD = {
  category: 'Non_RESP_Dashboard',
  label: 'Non_RESPDashboard',
  eventprefix: 'NRESP_DASH'
};

// TODO: Remove once old Dashboard code is removed.
export const EVENTCAT_OLD_RESP_DASHBOARD = {
  category: 'Old_Dashboard',
  label: 'Old_Dashboard',
  eventprefix: 'OLD_RESP'
};

export const MAKE_A_CONTRIBUTION = {
  category: 'Make a Contribution',
  label: 'Make a Contribution',
  eventprefix: 'SS_MakeContribution',
  paths: ['/contribute']
};

export const EVENTCAT_SEND_A_GIFT = {
  category: 'Send a Gift',
  label: 'Send a Gift',
  eventprefix: 'SG',
  paths: ['/send-a-gift']
};

export const EVENTCAT_GIFTING = {
  category: 'Gifting',
  label: 'Gifting',
  eventprefix: 'GIFT',
  paths: ['/gift']
};

export const EVENTCAT_CAREER_SCHOOL_MATCHER = {
  category: 'Career & School Matcher',
  label: 'Career & School Matcher',
  eventprefix: 'CSM',
  paths: ['/careers']
};

export const EVENTCAT_EXPECTING_PARENT = {
  category: 'ExpectingParent',
  label: 'ExpectingParent',
  eventprefix: 'EXP_PRNT',
  paths: ['/newbaby-onboarding']
};

export const EVENTCAT_STUDENT_SERVICES = {
  category: 'Student Services Homepage',
  label: 'Student Services Homepage',
  eventprefix: 'SSHP',
  paths: ['/main']
};

export const EVENTCAT_COST_OF_SCHOOL = {
  category: 'Cost of School',
  label: 'Cost of School',
  eventprefix: 'COS'
};

export const EVENTCAT_WITHDRAWAL_APPLICATION = {
  category: 'Withdrawal',
  label: 'Withdrawal',
  eventprefix: 'WITHDRAWAL',
  paths: ['/withdrawal']
};

export const EVENTCAT_SCHEDULED_CONTRIBUTIONS = {
  category: 'ScheduledContributions',
  label: 'ScheduledContributions',
  eventprefix: 'SC'
};

export const EVENTCAT_REFER_A_FRIEND = {
  category: 'ReferAFriendLandingPage',
  label: 'ReferAFriendLandingPage',
  eventprefix: 'REFER',
  paths: ['/resp/main/refer']
};

export const EVENTCAT_PLAN_SPECIFIC_DASHBOARD = {
  category: 'PlanSpecificDashboard',
  label: 'PlanSpecificDashboard',
  eventprefix: 'PSD'
};

export const EVENTCAT_PLAN_PORTFOLIO_DETAILS = {
  category: 'PortfolioDetails',
  label: 'PortfolioDetails',
  eventprefix: 'PD'
};

export const EVENTCAT_RIGHT_RAIL = {
  category: 'RightRail',
  label: 'RightRail',
  eventprefix: 'RR'
};

export const EVETCAT_MESSAGE_CENTER = {
  category: 'SecureMsgCentre',
  label: 'SecureMsgCentre',
  eventprefix: 'SMC',
  paths: ['/messages']
};

export const EVENTCAT_PLAID_FLINKS = {
  category: 'Plaid & Flinks',
  label: 'Plaid & Flinks',
  eventprefix: 'P&F'
};

export const eventCategoryDefinitions = [
  EVENTCAT_GENESYS_CHAT,
  EVENTCAT_EXPECTING_PARENT,
  EVENTCAT_ADD_A_BENE,
  EVENTCAT_ADD_A_PLAN,
  EVENTCAT_AUTH,
  EVENTCAT_SELF_ONBOARDING,
  EVENTCAT_SELF_ONBOARDING_APPLICATION,
  EVENTCAT_SELF_WITHDRAWAL_APPLICATION,
  EVENTCAT_SELF_COSUB_ONBOARDING_APPLICATION,
  EVENTCAT_SELF_TRANSFER_IN_APPLICATION,
  EVENTCAT_AIP_WITHDRAWAL_APPLICATION,
  EVENTCAT_ASSIS_ONBOARDING,
  EVENTCAT_INTEREST_QUESTIONNAIRE,
  EVENTCAT_REWARDS,
  EVENTCAT_RESP_DASHBOARD,
  EVENTCAT_NON_RESP_DASHBOARD,
  EVENTCAT_GIFTING,
  EVENTCAT_SEND_A_GIFT,
  MAKE_A_CONTRIBUTION,
  EVETCAT_MESSAGE_CENTER,
  EVENTCAT_REFER_A_FRIEND,
  EVENTCAT_STUDENT_SERVICES,
  EVENTCAT_CAREER_SCHOOL_MATCHER,
  EVENTCAT_DASHBOARD_COSUB_REMINDER,
  EVENTCAT_WITHDRAWAL_APPLICATION,
  EVENTCAT_SCHEDULED_CONTRIBUTIONS,
  EVENTCAT_WITHDRAWAL_APPLICATION,
  EVENTCAT_RIGHT_RAIL,
  EVENTCAT_PLAID_FLINKS
];

export function getEventCategoryFromLocation() {
  const eventCategory = eventCategoryDefinitions?.filter(
    (categoryDefination) =>
      categoryDefination.paths?.filter((path) =>
        window.location.href.includes(path)
      ).length > 0
  )[0];

  if (!eventCategory) {
    return { label: '--', category: '--', eventprefix: '' };
  } else {
    const { label, category, eventprefix } = eventCategory;
    return { label, category, eventprefix };
  }
}
